export const ENV_BR = {
  API: {
    TRAVEL: 'https://services.rappi.com.br/ms-travel/',
    PROFILE: 'https://services.rappi.com.br/ms-profile/',
    RULES: 'https://services.rappi.com.br/ms-rule-engine/',
    LOGIN: 'https://services.rappi.com.br/api/rocket/login/password/application_user',
    USER: 'https://services.rappi.com.br/ms/application-user/auth',
    COUNTRIES: 'https://restcountries.eu/rest/v2/',
    LOGIN_EXCHANGE: 'https://v2.dev.rappi.com/api/rocket/exchange/authorization_code',
    RAPPI_SERVICES: 'https://services.rappi.com.br/api/',
    RAPPI_SERVICES_CITIES: 'https://services.rappi.com.br/api/travel/search/',
    RAPPI_SERVICES_TRAVEL_CITY_SEARCH: 'https://services.grability.rappi.com/api/travel-city-search/',
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH: 'https://services.grability.rappi.com/api/travel-hotel-search/',
    RAPPI_SERVICES_TRAVEL_HOTEL_CONTENT: 'https://services.grability.rappi.com/travel-hotel-content/hotel-location/',
    RAPPI_IMAGES_CDN: 'https://images.rappi.com/',
  },
  API_KEYS: {
    GOOGLE_MAPS_API_KEY: 'AIzaSyByupaeP48OO86bOW1k_bFm5vMlDGU0azM',
    KUSTOMER_FORM_ID: '5f524de4f0a0d900963139d2',
    AMPLITUDE_KEY: '101be7b7fdda892d329579012e8dd69a',
  },
  RAPPI_OAUTH: {
    REDIRECT_URL_FROM_LOGIN: '',
    REDIRECT_URL_FROM_REGISTRATION: '',
    REDIRECT_URL_FROM_INVITE: '',
    LOGIN_CLIENTID: '',
    LOGIN_URL: '',
    SIGNUP_URL: '',
  },
  LANDING_PAGE: 'https://travel4business.rappi.com/',
  SENTRY_DSN: 'https://fe011ed6ec14461595fd1716c48e310d@o484725.ingest.sentry.io/5538357',
  SEARCH_MAX_RESULT_PER_PAGE: 9,
  COUNTRY_CODE: 55,
  RAPPI_BRANCH_CODE: 'CORP',
};
